import React from "react";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-nav">
      <div className="container">

        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
            src={require("../images/LandingPage/Cryptoants.png")}
            alt="Logo"
            className="logo-img"
          />
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">

            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#about">About Us</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#contact">Contact Us</a>
            </li>

          </ul>

          {/* Contact */}
          <div className="contact-text">
            <span>📞 Contact us : </span>
            <a href="tel:9321765323" className="contact-number">
              9321765323
            </a>
          </div>
        </div>

      </div>
    </nav>
  );
}
